import { render, staticRenderFns } from "./ImportAttendances.vue?vue&type=template&id=162e9967&"
import script from "./ImportAttendances.vue?vue&type=script&lang=js&"
export * from "./ImportAttendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports